var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0325 0.775665C18.9167 0.679506 18.7759 0.618241 18.6265 0.599009C18.4772 0.579776 18.3255 0.603366 18.1891 0.667033L1.81738 8.35156V9.83852L8.69383 12.5891L13.1046 19.375H14.5919L19.2911 1.58594C19.3292 1.44026 19.3251 1.28674 19.2793 1.14329C19.2336 0.99983 19.148 0.872337 19.0325 0.775665ZM13.6736 17.9568L9.88234 12.1238L15.7164 5.73391L14.7934 4.89109L8.91359 11.3308L3.24395 9.06297L17.8316 2.21563L13.6736 17.9568Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.c71468f40b1aa231ff9077de585f48b2.svg";
export { ForwardRef as ReactComponent };